export { default } from './WhoWeAreSection'